// Public asset URLs that work both on the server (base "/") and in the static preview (base "./").
const BASE = import.meta.env.BASE_URL || "/";

export function asset(path: string): string {
  const p = path.replace(/^\/+/, "");
  return BASE.endsWith("/") ? BASE + p : `${BASE}/${p}`;
}

export const IS_DEMO = typeof __DEMO__ !== "undefined" && __DEMO__;
